import React, {useState} from 'react';
import './index.css';

export function UserInput({initialUserName, setUserName}) {

    return <div style={{paddingBottom: "95px", width: "500px", height: "80px"}}>
        <div className={"name-input-header"}>Enter your Name</div>
        <input style={{
            backgroundColor: "black",
            opacity: "90%",
            lineHeight: "80px",
            borderWidth: "0px",
            width: "100%",
            height: "100%",
            fontFamily: "PlanetKosmos",
            fontSize: "50px",
            alignContent: "center",
            textAlign: "center",
            letterSpacing: "3px",
            color: "white"
        }} defaultValue={initialUserName} name="myInput" onInput={(ev) => setUserName(ev.target.value)}></input>
        <div></div>
    </div>;

}
